import { gql, useQuery } from "@apollo/client";

interface VehicleOption {
    label: string;
    value: number;
}

export interface VehicleType {
    id: number;
    vehicleNumber: string;
    licensePlate: string;
    status: number;
    vehicleModelId: number;
    vehicleModelName: string;
    vehicleTypeId?: number;
    vehicleTypeName?: string;
}

export const GET_VEHICLES_BY_WAREHOUSE_ID = gql`
    query GetVehiclesByWarehouseId($warehouseId: Long!) {
        vehicles: getVehiclesByWarehouseId(warehouseId: $warehouseId) {
            id
            vehicleNumber
            licensePlate
            status
            vehicleModelId
            vehicleModelName
            vehicleTypeId
            vehicleTypeName
        }
    }
`;

export interface GetVehiclesByWarehouseIdResponse {
    vehicles: VehicleType[];
}

export const useVehicleOptions = (warehouseId?: number) => {
    const { data, loading, error } = useQuery<GetVehiclesByWarehouseIdResponse>(
        GET_VEHICLES_BY_WAREHOUSE_ID,
        {
            variables: { warehouseId },
            skip: !warehouseId, // 如果没有warehouseId就跳过查询
        }
    );

    const vehicleOptions: VehicleOption[] = data?.vehicles
        ?.filter(vehicle => vehicle.status === 1) // 只显示可用状态的车辆
        ?.map(vehicle => ({
            value: vehicle.id,
            label: `${vehicle.vehicleNumber}-${vehicle.licensePlate}`, // 格式：车辆编号-车牌号
        })) || [];

    return {
        vehicleOptions,
        vehicles: data?.vehicles || [], // 返回原始车辆数据
        loading,
        error
    };
}; 